// @generated by protoc-gen-es v2.14.1 with parameter "target=ts,import_extension=js"
// @generated from file broadcast_live.proto (package chessstreamlive.broadcast.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Color, GameResult, MoveClass } from "./common_pb.js";
import { file_common } from "./common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file broadcast_live.proto.
 */
export const file_broadcast_live: GenFile = /*@__PURE__*/
  fileDesc("ChRicm9hZGNhc3RfbGl2ZS5wcm90bxIcY2hlc3NzdHJlYW1saXZlLmJyb2FkY2FzdC52MSKqAwoGVXBkYXRlEgsKA3NlcRgBIAEoBBIQCghldmVudF9pZBgHIAEoCRIVCg1leHBlcmltZW50X2lkGAggASgJEg8KB3ZhcmlhbnQYCSABKAkSGgoOcHJvZHVjZWRfdW5kZXIYCiABKAlCAhgBEjgKBGdhbWUYAiABKAsyKC5jaGVzc3N0cmVhbWxpdmUuYnJvYWRjYXN0LnYxLkdhbWVVcGRhdGVIABI5CgZjbG9ja3MYAyABKAsyJy5jaGVzc3N0cmVhbWxpdmUuYnJvYWRjYXN0LnYxLkNsb2NrU3luY0gAEkQKCmNvbW1lbnRhcnkYBCABKAsyLi5jaGVzc3N0cmVhbWxpdmUuYnJvYWRjYXN0LnYxLkNvbW1lbnRhcnlVcGRhdGVIABI/CghmaW5pc2hlZBgFIAEoCzIrLmNoZXNzc3RyZWFtbGl2ZS5icm9hZGNhc3QudjEuUm91bmRGaW5pc2hlZEgAEjgKBGV2YWwYBiABKAsyKC5jaGVzc3N0cmVhbWxpdmUuYnJvYWRjYXN0LnYxLkV2YWxVcGRhdGVIAEIHCgVldmVudCLVBAoKR2FtZVVwZGF0ZRIQCghyb3VuZF9pZBgBIAEoCRIQCghib2FyZF9pZBgCIAEoDRILCgNwZ24YAyABKAkSFQoId19jbGtfbXMYBCABKARIAIgBARIVCghiX2Nsa19tcxgFIAEoBEgBiAEBEjAKBmFjdGl2ZRgGIAEoDjIgLmNoZXNzc3RyZWFtbGl2ZS5jb21tb24udjEuQ29sb3ISEwoLcmVsYXlfdHNfbXMYByABKAQSNQoGcmVzdWx0GAggASgOMiUuY2hlc3NzdHJlYW1saXZlLmNvbW1vbi52MS5HYW1lUmVzdWx0EjoKCWh5ZHJhdGlvbhgJIAEoCzInLmNoZXNzc3RyZWFtbGl2ZS5icm9hZGNhc3QudjEuSHlkcmF0aW9uEhYKDnByb2R1Y2VkX3VuZGVyGAogASgJEjEKBW1vdmVzGAsgAygLMiIuY2hlc3NzdHJlYW1saXZlLmJyb2FkY2FzdC52MS5Nb3ZlEj0KC21vdmVzX2Jhc2lzGAwgASgOMiguY2hlc3NzdHJlYW1saXZlLmJyb2FkY2FzdC52MS5Nb3Zlc0Jhc2lzEhYKCXN0YXJ0X2ZlbhgNIAEoCUgCiAEBEhQKB3ZhcmlhbnQYDiABKAlIA4gBARIZCgx0aW1lX2NvbnRyb2wYDyABKAlIBIgBARIWCg5lbnJpY2htZW50X2tleRgQIAEoCUILCglfd19jbGtfbXNCCwoJX2JfY2xrX21zQgwKCl9zdGFydF9mZW5CCgoIX3ZhcmlhbnRCDwoNX3RpbWVfY29udHJvbCLVAgoJSHlkcmF0aW9uEjYKB29wZW5pbmcYASABKAsyJS5jaGVzc3N0cmVhbWxpdmUuYnJvYWRjYXN0LnYxLk9wZW5pbmcSFwoKaXNfbm92ZWx0eRgCIAEoCEgAiAEBEhwKD25vdmVsdHlfY29udGV4dBgDIAEoCUgBiAEBEjcKBXdoaXRlGAQgASgLMiguY2hlc3NzdHJlYW1saXZlLmJyb2FkY2FzdC52MS5QbGF5ZXJDYXJkEjcKBWJsYWNrGAUgASgLMiguY2hlc3NzdHJlYW1saXZlLmJyb2FkY2FzdC52MS5QbGF5ZXJDYXJkEkQKDnBvc2l0aW9uX2Jhc2lzGAYgASgOMiwuY2hlc3NzdHJlYW1saXZlLmJyb2FkY2FzdC52MS5IeWRyYXRpb25CYXNpc0INCgtfaXNfbm92ZWx0eUISChBfbm92ZWx0eV9jb250ZXh0IiQKB09wZW5pbmcSCwoDZWNvGAEgASgJEgwKBG5hbWUYAiABKAkizwEKClBsYXllckNhcmQSDwoHZmlkZV9pZBgBIAEoBBIQCgNlbG8YAiABKA1IAIgBARIVCghwZWFrX2VsbxgDIAEoDUgBiAEBEhIKBXRpdGxlGAQgASgJSAKIAQESMgoFdHJlbmQYBSABKA4yIy5jaGVzc3N0cmVhbWxpdmUuYnJvYWRjYXN0LnYxLlRyZW5kEgwKBG5hbWUYBiABKAkSEgoKZmVkZXJhdGlvbhgHIAEoCUIGCgRfZWxvQgsKCV9wZWFrX2Vsb0IICgZfdGl0bGUi4gEKBE1vdmUSCwoDcGx5GAEgASgNEgsKA3NhbhgCIAEoCRILCgN1Y2kYAyABKAkSDAoCY3AYBCABKBFIABIOCgRtYXRlGAUgASgRSAASFwoKZXZhbF9kZXB0aBgGIAEoDUgBiAEBEhUKCGNsb2NrX21zGAcgASgESAKIAQESFAoHY29tbWVudBgIIAEoCUgDiAEBEgwKBG5hZ3MYCSADKA1CBgoEZXZhbEINCgtfZXZhbF9kZXB0aEILCglfY2xvY2tfbXNCCgoIX2NvbW1lbnRKBAgKEAtSC2Fubm90YXRpb25zIlEKEENvbW1lbnRhcnlVcGRhdGUSEAoIcm91bmRfaWQYASABKAkSEAoIYm9hcmRfaWQYAiABKA0SCwoDcGx5GAMgASgNEgwKBHRleHQYBCABKAki2gEKCkV2YWxVcGRhdGUSEAoIcm91bmRfaWQYASABKAkSEAoIYm9hcmRfaWQYAiABKA0SCwoDcGx5GAMgASgNEgwKAmNwGAQgASgRSAASDgoEbWF0ZRgFIAEoEUgAEg0KBWRlcHRoGAYgASgNEhoKDWJlc3RfbW92ZV91Y2kYByABKAlIAYgBARI4Cgptb3ZlX2NsYXNzGAggASgOMiQuY2hlc3NzdHJlYW1saXZlLmNvbW1vbi52MS5Nb3ZlQ2xhc3NCBgoEZXZhbEIQCg5fYmVzdF9tb3ZlX3VjaSKBAQoJQ2xvY2tTeW5jEhAKCHJvdW5kX2lkGAEgASgJEjgKBmNsb2NrcxgCIAMoCzIoLmNoZXNzc3RyZWFtbGl2ZS5icm9hZGNhc3QudjEuQ2xvY2tFbnRyeRIYCgtsYXN0X3Bnbl9tcxgDIAEoBEgAiAEBQg4KDF9sYXN0X3Bnbl9tcyKnAQoKQ2xvY2tFbnRyeRIQCghib2FyZF9pZBgBIAEoDRIVCgh3X2Nsa19tcxgCIAEoBEgAiAEBEhUKCGJfY2xrX21zGAMgASgESAGIAQESMAoGYWN0aXZlGAQgASgOMiAuY2hlc3NzdHJlYW1saXZlLmNvbW1vbi52MS5Db2xvchINCgV0c19tcxgFIAEoBEILCglfd19jbGtfbXNCCwoJX2JfY2xrX21zIiEKDVJvdW5kRmluaXNoZWQSEAoIcm91bmRfaWQYASABKAkiNwoQU3Vic2NyaWJlUmVxdWVzdBIQCghyb3VuZF9pZBgBIAEoCRIRCglib2FyZF9pZHMYAiADKA0iXQoQU25hcHNob3RSZXNwb25zZRI3CgVnYW1lcxgBIAMoCzIoLmNoZXNzc3RyZWFtbGl2ZS5icm9hZGNhc3QudjEuR2FtZVVwZGF0ZRIQCghmaW5pc2hlZBgCIAEoCCI1ChFMaXN0Um91bmRzUmVxdWVzdBIUCgd0b3VyX2lkGAEgASgJSACIAQFCCgoIX3RvdXJfaWQicAoSTGlzdFJvdW5kc1Jlc3BvbnNlEj0KC3RvdXJuYW1lbnRzGAEgAygLMiguY2hlc3NzdHJlYW1saXZlLmJyb2FkY2FzdC52MS5Ub3VybmFtZW50EhsKE21pbl9zdXBwb3J0ZWRfYnVpbGQYAiABKA0ijwIKClRvdXJuYW1lbnQSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRIMCgRzbHVnGAMgASgJEjoKBGluZm8YBCABKAsyLC5jaGVzc3N0cmVhbWxpdmUuYnJvYWRjYXN0LnYxLlRvdXJuYW1lbnRJbmZvEhIKCmNyZWF0ZWRfYXQYBSABKAMSCwoDdXJsGAYgASgJEhEKBHRpZXIYByABKAVIAIgBARINCgVkYXRlcxgIIAMoAxISCgVpbWFnZRgJIAEoCUgBiAEBEjMKBnJvdW5kcxgKIAMoCzIjLmNoZXNzc3RyZWFtbGl2ZS5icm9hZGNhc3QudjEuUm91bmRCBwoFX3RpZXJCCAoGX2ltYWdlIp4CCg5Ub3VybmFtZW50SW5mbxITCgZmb3JtYXQYASABKAlIAIgBARIPCgJ0YxgCIAEoCUgBiAEBEhQKB2ZpZGVfdGMYAyABKAlIAogBARIVCghsb2NhdGlvbhgEIAEoCUgDiAEBEhYKCXRpbWVfem9uZRgFIAEoCUgEiAEBEhQKB3BsYXllcnMYBiABKAlIBYgBARIUCgd3ZWJzaXRlGAcgASgJSAaIAQESFgoJc3RhbmRpbmdzGAggASgJSAeIAQFCCQoHX2Zvcm1hdEIFCgNfdGNCCgoIX2ZpZGVfdGNCCwoJX2xvY2F0aW9uQgwKCl90aW1lX3pvbmVCCgoIX3BsYXllcnNCCgoIX3dlYnNpdGVCDAoKX3N0YW5kaW5ncyKSAQoFUm91bmQSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRIMCgRzbHVnGAMgASgJEg8KB29uZ29pbmcYBCABKAgSEAoIZmluaXNoZWQYBSABKAgSFgoJc3RhcnRzX2F0GAYgASgDSACIAQESEAoDdXJsGAcgASgJSAGIAQFCDAoKX3N0YXJ0c19hdEIGCgRfdXJsKooBCg5IeWRyYXRpb25CYXNpcxIfChtIWURSQVRJT05fQkFTSVNfVU5TUEVDSUZJRUQQABIcChhIWURSQVRJT05fQkFTSVNfQ09NUFVURUQQARIbChdIWURSQVRJT05fQkFTSVNfU0tJUFBFRBACEhwKGEhZRFJBVElPTl9CQVNJU19ERUdSQURFRBADKk4KBVRyZW5kEhUKEVRSRU5EX1VOU1BFQ0lGSUVEEAASDAoIVFJFTkRfVVAQARIQCgxUUkVORF9TVEFCTEUQAhIOCgpUUkVORF9ET1dOEAMqXQoKTW92ZXNCYXNpcxIbChdNT1ZFU19CQVNJU19VTlNQRUNJRklFRBAAEhgKFE1PVkVTX0JBU0lTX0NPTVBMRVRFEAESGAoUTU9WRVNfQkFTSVNfREVHUkFERUQQAjLhAQoJQnJvYWRjYXN0EmMKCVN1YnNjcmliZRIuLmNoZXNzc3RyZWFtbGl2ZS5icm9hZGNhc3QudjEuU3Vic2NyaWJlUmVxdWVzdBokLmNoZXNzc3RyZWFtbGl2ZS5icm9hZGNhc3QudjEuVXBkYXRlMAESbwoKTGlzdFJvdW5kcxIvLmNoZXNzc3RyZWFtbGl2ZS5icm9hZGNhc3QudjEuTGlzdFJvdW5kc1JlcXVlc3QaMC5jaGVzc3N0cmVhbWxpdmUuYnJvYWRjYXN0LnYxLkxpc3RSb3VuZHNSZXNwb25zZUIhCh1jb20uY2hlc3NzdHJlYW1saXZlLmJyb2FkY2FzdFABYgZwcm90bzM", [file_common]);

/**
 * @generated from message chessstreamlive.broadcast.v1.Update
 */
export type Update = Message<"chessstreamlive.broadcast.v1.Update"> & {
  /**
   * Hop-1 ONLY (relay → distributor): per-round monotonic, relay-assigned;
   * the distributor drops seq ≤ last-seen to defuse retried-POST reordering.
   * The counter resets on relay restart and synthetic bodies (snapshots,
   * heals, finish markers) carry 0 — it is NOT a client-usable ordering key.
   *
   * Hop 2 (distributor → clients): always 0 — zeroed at fan-out. Clients
   * MUST apply updates in stream order and MUST NOT compare seq values;
   * full-PGN snapshot semantics make every GameUpdate self-superseding.
   *
   * @generated from field: uint64 seq = 1;
   */
  seq: bigint;

  /**
   * Globally unique, time-sortable correlation key (UUIDv7 string).
   * Minted once at relay-ingest notify(); forwarded verbatim by all downstream
   * hops (distributor, app). Empty on legacy/synthetic bodies and old relays;
   * consumers MUST tolerate empty.
   * See docs/infra/observability-architecture-2026-06.md §4–5.
   *
   * @generated from field: string event_id = 7;
   */
  eventId: string;

  /**
   * Experiment/variant under which this body's enrichment was produced. Resolved
   * once per round (EnrichmentPlan — design #785 §3) and forwarded verbatim by all
   * downstream hops. Empty on legacy/synthetic bodies and old relays; consumers
   * MUST tolerate empty. Per-EVENT latency-slicing tags (like event_id) — empty on
   * the distributor's resynthesized snapshot/late-join burst is correct; the
   * durable per-experiment breakdown lives in event_log SegmentHeader (#806).
   * When a round layers multiple experiments these are a deterministic comma-join
   * of every assignment (id,id and variant,variant, same order).
   *
   * @generated from field: string experiment_id = 8;
   */
  experimentId: string;

  /**
   * @generated from field: string variant = 9;
   */
  variant: string;

  /**
   * DEPRECATED — board-render provenance moved to GameUpdate.produced_under (#810):
   * the envelope is dropped when the distributor resynthesizes a snapshot body
   * (CachedGame::new), so a late-joiner to a quiet board would lose it. Kept only
   * because buf forbids removing a field; producers no longer set it. Read
   * GameUpdate.produced_under instead.
   *
   * @generated from field: string produced_under = 10 [deprecated = true];
   * @deprecated
   */
  producedUnder: string;

  /**
   * Clients MUST skip-and-count unknown arms, never crash (README rule 4).
   *
   * @generated from oneof chessstreamlive.broadcast.v1.Update.event
   */
  event: {
    /**
     * @generated from field: chessstreamlive.broadcast.v1.GameUpdate game = 2;
     */
    value: GameUpdate;
    case: "game";
  } | {
    /**
     * @generated from field: chessstreamlive.broadcast.v1.ClockSync clocks = 3;
     */
    value: ClockSync;
    case: "clocks";
  } | {
    /**
     * @generated from field: chessstreamlive.broadcast.v1.CommentaryUpdate commentary = 4;
     */
    value: CommentaryUpdate;
    case: "commentary";
  } | {
    /**
     * @generated from field: chessstreamlive.broadcast.v1.RoundFinished finished = 5;
     */
    value: RoundFinished;
    case: "finished";
  } | {
    /**
     * @generated from field: chessstreamlive.broadcast.v1.EvalUpdate eval = 6;
     */
    value: EvalUpdate;
    case: "eval";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chessstreamlive.broadcast.v1.Update.
 * Use `create(UpdateSchema)` to create a new message.
 */
export const UpdateSchema: GenMessage<Update> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 0);

/**
 * @generated from message chessstreamlive.broadcast.v1.GameUpdate
 */
export type GameUpdate = Message<"chessstreamlive.broadcast.v1.GameUpdate"> & {
  /**
   * @generated from field: string round_id = 1;
   */
  roundId: string;

  /**
   * @generated from field: uint32 board_id = 2;
   */
  boardId: number;

  /**
   * Full PGN — snapshot semantics: supersedes every prior update for this
   * board. Reconnect/late-join recovery is "resend latest GameUpdate".
   * Retained verbatim as the fidelity escrow (#915).
   *
   * @generated from field: string pgn = 3;
   */
  pgn: string;

  /**
   * Remaining clock, milliseconds. Absent when the PGN carries no [%clk].
   *
   * This is the broadcast's [%clk] as-is, with ONE correction: when a
   * period bonus is owed from a side's period-closing move and the source has
   * not yet reflected it in that side's readings (possibly several moves
   * later, or never), the relay credits that bonus here.
   * A reading the source HAS revised is never credited twice. Clients therefore never add
   * increment or period bonuses themselves — they tick the active side down
   * from relay_ts_ms and display these values. The credit comes from the same
   * period model the clock heal reads
   * (relay-ingest/src/time_control.rs::side_credited_gain).
   *
   * @generated from field: optional uint64 w_clk_ms = 4;
   */
  wClkMs?: bigint | undefined;

  /**
   * @generated from field: optional uint64 b_clk_ms = 5;
   */
  bClkMs?: bigint | undefined;

  /**
   * @generated from field: chessstreamlive.common.v1.Color active = 6;
   */
  active: Color;

  /**
   * Epoch ms when the relay computed this state; drives client clock ticking.
   *
   * @generated from field: uint64 relay_ts_ms = 7;
   */
  relayTsMs: bigint;

  /**
   * @generated from field: chessstreamlive.common.v1.GameResult result = 8;
   */
  result: GameResult;

  /**
   * Fast-path enrichment (µs-scale lookups). May be absent entirely; every
   * field optional so the pipeline ships before all sources are live.
   *
   * @generated from field: chessstreamlive.broadcast.v1.Hydration hydration = 9;
   */
  hydration?: Hydration | undefined;

  /**
   * Which enrichment plan produced this board — a compact, deterministic
   * fingerprint of the resolved EnrichmentPlan (which enrichers ran). The app
   * reads it to adapt its layout. Lives on GameUpdate (not the Update envelope,
   * #806) because GameUpdate is always present and survives the distributor's
   * snapshot cache — so a late-joiner to a quiet board still gets render
   * provenance. Empty ⇒ render the default layout (legacy/synthetic bodies).
   *
   * @generated from field: string produced_under = 10;
   */
  producedUnder: string;

  /**
   * Structured move snapshot — full list every push, self-superseding with
   * exactly the pgn field's snapshot semantics. Pure function of pgn.
   *
   * @generated from field: repeated chessstreamlive.broadcast.v1.Move moves = 11;
   */
  moves: Move[];

  /**
   * Why moves[] may be partial or absent — a statement, not a gap (see MovesBasis).
   *
   * @generated from field: chessstreamlive.broadcast.v1.MovesBasis moves_basis = 12;
   */
  movesBasis: MovesBasis;

  /**
   * Non-standard start position ([FEN]/[SetUp] headers) and variant tag,
   * verbatim from the feed. Absent = standard start. #743.
   *
   * @generated from field: optional string start_fen = 13;
   */
  startFen?: string | undefined;

  /**
   * @generated from field: optional string variant = 14;
   */
  variant?: string | undefined;

  /**
   * The game's time control in PGN TimeControl grammar (e.g. "5400+30",
   * "40/5400+30:1800+30"): the `[TimeControl]` header verbatim when the PGN
   * carries one, else the CANONICAL TAG derived from the tour's free-text
   * control (Lichess `tour.info.tc`, e.g. "90 min / 40 moves + 30 min + 30 sec
   * / move") — many broadcasts publish no header at all. Absent means neither
   * source said anything readable; it is never a guessed zero increment.
   * Producer: relay-ingest `moves_builder.rs` / `stream_manager.rs`. Issue 2459.
   *
   * @generated from field: optional string time_control = 15;
   */
  timeControl?: string | undefined;

  /**
   * DIRECTLY DEREFERENCEABLE public URL of this game's durable enrichment
   * manifest — `${PACK_BASE_URL}/g/<game_uid>/enrichment.pb` (#1766). The server
   * builds it from its own private `game_uid` (= H(round_id, board_id)) and
   * relative object key; the client GETs this string VERBATIM to fetch the
   * EnrichmentManifest (evals + commentary pointers) — see enrichment.proto.
   * Clients never hash a game_uid, never LIST the bucket, and NEVER construct
   * keys (#765), so the address stays provider/environment-portable.
   * Empty ⇒ the enrichment plane is OFF for this game — either the round's
   * EnrichmentPlan disabled the lane, or the plane is not both writable
   * (ENRICHMENT_STORE) and publicly readable (PACK_BASE_URL). Absence is a
   * statement: the client never fetches.
   * Stable from move 1 through finalization forever. D10.
   *
   * @generated from field: string enrichment_key = 16;
   */
  enrichmentKey: string;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.GameUpdate.
 * Use `create(GameUpdateSchema)` to create a new message.
 */
export const GameUpdateSchema: GenMessage<GameUpdate> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 1);

/**
 * @generated from message chessstreamlive.broadcast.v1.Hydration
 */
export type Hydration = Message<"chessstreamlive.broadcast.v1.Hydration"> & {
  /**
   * @generated from field: chessstreamlive.broadcast.v1.Opening opening = 1;
   */
  opening?: Opening | undefined;

  /**
   * @generated from field: optional bool is_novelty = 2;
   */
  isNovelty?: boolean | undefined;

  /**
   * e.g. "vs 14...Qe7 (3412 games)"
   *
   * @generated from field: optional string novelty_context = 3;
   */
  noveltyContext?: string | undefined;

  /**
   * @generated from field: chessstreamlive.broadcast.v1.PlayerCard white = 4;
   */
  white?: PlayerCard | undefined;

  /**
   * @generated from field: chessstreamlive.broadcast.v1.PlayerCard black = 5;
   */
  black?: PlayerCard | undefined;

  /**
   * Why the position-derived components (opening, is_novelty,
   * novelty_context) may be absent. Consumers MUST NOT backfill an absence
   * under an authoritative basis (COMPUTED / SKIPPED) — it is a statement,
   * not a gap. Player cards are position-independent and outside this
   * basis. Absent on legacy producers (= UNSPECIFIED). #732.
   *
   * @generated from field: chessstreamlive.broadcast.v1.HydrationBasis position_basis = 6;
   */
  positionBasis: HydrationBasis;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.Hydration.
 * Use `create(HydrationSchema)` to create a new message.
 */
export const HydrationSchema: GenMessage<Hydration> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 2);

/**
 * @generated from message chessstreamlive.broadcast.v1.Opening
 */
export type Opening = Message<"chessstreamlive.broadcast.v1.Opening"> & {
  /**
   * e.g. "B90"
   *
   * @generated from field: string eco = 1;
   */
  eco: string;

  /**
   * e.g. "Sicilian Najdorf"
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.Opening.
 * Use `create(OpeningSchema)` to create a new message.
 */
export const OpeningSchema: GenMessage<Opening> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 3);

/**
 * @generated from message chessstreamlive.broadcast.v1.PlayerCard
 */
export type PlayerCard = Message<"chessstreamlive.broadcast.v1.PlayerCard"> & {
  /**
   * @generated from field: uint64 fide_id = 1;
   */
  fideId: bigint;

  /**
   * @generated from field: optional uint32 elo = 2;
   */
  elo?: number | undefined;

  /**
   * @generated from field: optional uint32 peak_elo = 3;
   */
  peakElo?: number | undefined;

  /**
   * @generated from field: optional string title = 4;
   */
  title?: string | undefined;

  /**
   * @generated from field: chessstreamlive.broadcast.v1.Trend trend = 5;
   */
  trend: Trend;

  /**
   * Display name, verbatim from the feed headers. Load-bearing: the PGN
   * header is today the client's only name source; this field replaces it.
   *
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * Federation/team as published (e.g. "IND"); replaces client-side
   * [WhiteTeam]/[WhiteFed] header reads.
   *
   * @generated from field: string federation = 7;
   */
  federation: string;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.PlayerCard.
 * Use `create(PlayerCardSchema)` to create a new message.
 */
export const PlayerCardSchema: GenMessage<PlayerCard> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 4);

/**
 * One ply of the structured move snapshot. Every Move field is a PURE
 * FUNCTION of GameUpdate.pgn (the purity rule, #915): byte-identical pgn
 * MUST yield byte-identical moves. Data that is not derivable from the pgn
 * (engine evals, generated commentary, relay-computed marks) NEVER rides
 * here — it belongs to EvalUpdate / CommentaryUpdate / Hydration.
 *
 * @generated from message chessstreamlive.broadcast.v1.Move
 */
export type Move = Message<"chessstreamlive.broadcast.v1.Move"> & {
  /**
   * 1-based, PGN-relative — same convention as EvalUpdate.ply /
   * CommentaryUpdate.ply (#301).
   *
   * @generated from field: uint32 ply = 1;
   */
  ply: number;

  /**
   * @generated from field: string san = 2;
   */
  san: string;

  /**
   * Castling is encoded king-takes-rook (e.g. "e1h1") — the only encoding
   * that stays unambiguous under Chess960 start positions.
   *
   * @generated from field: string uci = 3;
   */
  uci: string;

  /**
   * Feed-embedded [%eval] only (side-to-move POV as published). Engine
   * evals ride EvalUpdate; consumers prefer EvalUpdate for the same ply.
   *
   * @generated from oneof chessstreamlive.broadcast.v1.Move.eval
   */
  eval: {
    /**
     * @generated from field: sint32 cp = 4;
     */
    value: number;
    case: "cp";
  } | {
    /**
     * @generated from field: sint32 mate = 5;
     */
    value: number;
    case: "mate";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional uint32 eval_depth = 6;
   */
  evalDepth?: number | undefined;

  /**
   * Historical per-ply [%clk] (mover's remaining clock after the move).
   * The top-level GameUpdate w_clk_ms/b_clk_ms + relay_ts_ms remain the
   * SOLE live-clock source — ClockSync patches those in place, never this.
   *
   * @generated from field: optional uint64 clock_ms = 7;
   */
  clockMs?: bigint | undefined;

  /**
   * Free-text comment with ALL %-tags stripped by the producer; <= 512 bytes.
   *
   * @generated from field: optional string comment = 8;
   */
  comment?: string | undefined;

  /**
   * Broadcaster-authored NAG glyphs ($1..$6 etc.), verbatim from the feed.
   * Distinct provenance from relay-computed classifications (Hydration).
   *
   * @generated from field: repeated uint32 nags = 9;
   */
  nags: number[];
};

/**
 * Describes the message chessstreamlive.broadcast.v1.Move.
 * Use `create(MoveSchema)` to create a new message.
 */
export const MoveSchema: GenMessage<Move> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 5);

/**
 * Slow path — arrives seconds after the move it annotates; never blocks
 * GameUpdate. Generated on the Mac Studio (validator-gated; silence > slop).
 *
 * @generated from message chessstreamlive.broadcast.v1.CommentaryUpdate
 */
export type CommentaryUpdate = Message<"chessstreamlive.broadcast.v1.CommentaryUpdate"> & {
  /**
   * @generated from field: string round_id = 1;
   */
  roundId: string;

  /**
   * @generated from field: uint32 board_id = 2;
   */
  boardId: number;

  /**
   * 1-based, relative to the moves in THIS board's broadcast PGN — ply 1 is the first half-move in
   * the PGN (White's first move in a standard game). Updates can outrun commentary, so ply pins the
   * target move. A producer that counts plies 0-based (e.g. analysis-server's `ply_index`) MUST emit
   * `ply_index + 1`.
   *
   * @generated from field: uint32 ply = 3;
   */
  ply: number;

  /**
   * @generated from field: string text = 4;
   */
  text: string;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.CommentaryUpdate.
 * Use `create(CommentaryUpdateSchema)` to create a new message.
 */
export const CommentaryUpdateSchema: GenMessage<CommentaryUpdate> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 6);

/**
 * Slow path — analysis-server evals (launch scope per 2026-06-12 decision).
 *
 * @generated from message chessstreamlive.broadcast.v1.EvalUpdate
 */
export type EvalUpdate = Message<"chessstreamlive.broadcast.v1.EvalUpdate"> & {
  /**
   * @generated from field: string round_id = 1;
   */
  roundId: string;

  /**
   * @generated from field: uint32 board_id = 2;
   */
  boardId: number;

  /**
   * 1-based, relative to the moves in THIS board's broadcast PGN — ply 1 is the first half-move in
   * the PGN (White's first move in a standard game). A producer that counts plies 0-based (e.g.
   * analysis-server's `ply_index`) MUST emit `ply_index + 1`.
   *
   * @generated from field: uint32 ply = 3;
   */
  ply: number;

  /**
   * @generated from oneof chessstreamlive.broadcast.v1.EvalUpdate.eval
   */
  eval: {
    /**
     * centipawns, white-positive
     *
     * @generated from field: sint32 cp = 4;
     */
    value: number;
    case: "cp";
  } | {
    /**
     * mate in N (negative = black mates)
     *
     * @generated from field: sint32 mate = 5;
     */
    value: number;
    case: "mate";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: uint32 depth = 6;
   */
  depth: number;

  /**
   * The engine's recommended NEXT move: the FIRST move of the principal variation FROM the
   * position this update evaluates (the position AFTER `ply`), in the UCI long-algebraic form the
   * engine emits — `e2e4`, promotion `e7e8q`, castling as the king's move (`e1g1`). Same semantics
   * and same wording as `EvalPoint.best_move_uci` (enrichment.proto), which is the durable twin of
   * this field on the R2 manifest.
   *
   * It is NOT "the move that should have been played at `ply`". A reader that wants "Ng5 was best
   * instead of the move played at ply p" holds the update for **p-1** and compares its
   * `best_move_uci` with the move actually played at p.
   *
   * Absent (not empty) when the engine returned no principal variation — a terminal position, or a
   * producer/relay build older than #2381. NOTE for readers: the Cloud Run distributor re-encodes
   * `Update` with prost, so it DROPS this field until it is rebuilt; the R2 enrichment manifest
   * (`EvalPoint.best_move_uci`) bypasses that hop and carries it first.
   *
   * @generated from field: optional string best_move_uci = 7;
   */
  bestMoveUci?: string | undefined;

  /**
   * How good the move PLAYED AT `ply` was — the analysis-server's own verdict
   * (`MoveInsights.classification`, `classify.rs::classify_move`), forwarded
   * rather than recomputed.
   *
   * NOTE THE ASYMMETRY with `best_move_uci` above, which is deliberate and is
   * what makes one point renderable on its own: `move_class` looks BACKWARD at
   * the move that produced this position, `best_move_uci` looks FORWARD to the
   * move the engine wants next. So "Nc3 was a mistake — Ng5 was best" is read
   * off TWO points: the class from the point at ply p, the recommendation from
   * the point at ply p-1.
   *
   * MOVE_CLASS_UNSPECIFIED is the absent value (no `optional` needed): the
   * analysis-server emits insights only for plies where BOTH surrounding
   * positions were evaluated, so an in-flight or aborted stream legitimately
   * has none, as does any relay build older than #2381.
   *
   * @generated from field: chessstreamlive.common.v1.MoveClass move_class = 8;
   */
  moveClass: MoveClass;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.EvalUpdate.
 * Use `create(EvalUpdateSchema)` to create a new message.
 */
export const EvalUpdateSchema: GenMessage<EvalUpdate> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 7);

/**
 * Periodic clock correction for all active games in a round. Emitted every
 * 60s per active round — protocol invariant: doubles as in-stream keepalive,
 * and is emitted even when `clocks` is empty (clockless club events still
 * keep the stream warm; an empty ClockSync is wire-valid — R12).
 *
 * Staleness: do NOT infer it from ClockSync absence alone (the ticker is a
 * timer, decoupled from upstream health). Judge data freshness from
 * `last_pgn_ms`: if now - last_pgn_ms grows while ClockSyncs keep arriving,
 * the relay's upstream has stalled and clocks/boards are frozen.
 *
 * @generated from message chessstreamlive.broadcast.v1.ClockSync
 */
export type ClockSync = Message<"chessstreamlive.broadcast.v1.ClockSync"> & {
  /**
   * @generated from field: string round_id = 1;
   */
  roundId: string;

  /**
   * @generated from field: repeated chessstreamlive.broadcast.v1.ClockEntry clocks = 2;
   */
  clocks: ClockEntry[];

  /**
   * Epoch ms of the round's most recent PGN-derived board update at the
   * relay. Absent only before the first board arrives.
   *
   * @generated from field: optional uint64 last_pgn_ms = 3;
   */
  lastPgnMs?: bigint | undefined;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.ClockSync.
 * Use `create(ClockSyncSchema)` to create a new message.
 */
export const ClockSyncSchema: GenMessage<ClockSync> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 8);

/**
 * @generated from message chessstreamlive.broadcast.v1.ClockEntry
 */
export type ClockEntry = Message<"chessstreamlive.broadcast.v1.ClockEntry"> & {
  /**
   * @generated from field: uint32 board_id = 1;
   */
  boardId: number;

  /**
   * @generated from field: optional uint64 w_clk_ms = 2;
   */
  wClkMs?: bigint | undefined;

  /**
   * @generated from field: optional uint64 b_clk_ms = 3;
   */
  bClkMs?: bigint | undefined;

  /**
   * @generated from field: chessstreamlive.common.v1.Color active = 4;
   */
  active: Color;

  /**
   * @generated from field: uint64 ts_ms = 5;
   */
  tsMs: bigint;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.ClockEntry.
 * Use `create(ClockEntrySchema)` to create a new message.
 */
export const ClockEntrySchema: GenMessage<ClockEntry> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 9);

/**
 * @generated from message chessstreamlive.broadcast.v1.RoundFinished
 */
export type RoundFinished = Message<"chessstreamlive.broadcast.v1.RoundFinished"> & {
  /**
   * @generated from field: string round_id = 1;
   */
  roundId: string;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.RoundFinished.
 * Use `create(RoundFinishedSchema)` to create a new message.
 */
export const RoundFinishedSchema: GenMessage<RoundFinished> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 10);

/**
 * @generated from message chessstreamlive.broadcast.v1.SubscribeRequest
 */
export type SubscribeRequest = Message<"chessstreamlive.broadcast.v1.SubscribeRequest"> & {
  /**
   * @generated from field: string round_id = 1;
   */
  roundId: string;

  /**
   * Empty = all boards in the round (multiboard view).
   *
   * @generated from field: repeated uint32 board_ids = 2;
   */
  boardIds: number[];
};

/**
 * Describes the message chessstreamlive.broadcast.v1.SubscribeRequest.
 * Use `create(SubscribeRequestSchema)` to create a new message.
 */
export const SubscribeRequestSchema: GenMessage<SubscribeRequest> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 11);

/**
 * @generated from message chessstreamlive.broadcast.v1.SnapshotResponse
 */
export type SnapshotResponse = Message<"chessstreamlive.broadcast.v1.SnapshotResponse"> & {
  /**
   * @generated from field: repeated chessstreamlive.broadcast.v1.GameUpdate games = 1;
   */
  games: GameUpdate[];

  /**
   * @generated from field: bool finished = 2;
   */
  finished: boolean;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.SnapshotResponse.
 * Use `create(SnapshotResponseSchema)` to create a new message.
 */
export const SnapshotResponseSchema: GenMessage<SnapshotResponse> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 12);

/**
 * @generated from message chessstreamlive.broadcast.v1.ListRoundsRequest
 */
export type ListRoundsRequest = Message<"chessstreamlive.broadcast.v1.ListRoundsRequest"> & {
  /**
   * Empty = active + upcoming tournaments.
   *
   * @generated from field: optional string tour_id = 1;
   */
  tourId?: string | undefined;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.ListRoundsRequest.
 * Use `create(ListRoundsRequestSchema)` to create a new message.
 */
export const ListRoundsRequestSchema: GenMessage<ListRoundsRequest> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 13);

/**
 * @generated from message chessstreamlive.broadcast.v1.ListRoundsResponse
 */
export type ListRoundsResponse = Message<"chessstreamlive.broadcast.v1.ListRoundsResponse"> & {
  /**
   * @generated from field: repeated chessstreamlive.broadcast.v1.Tournament tournaments = 1;
   */
  tournaments: Tournament[];

  /**
   * Client kill switch: builds below this must prompt for update
   * (implementation plan §4.1).
   *
   * @generated from field: uint32 min_supported_build = 2;
   */
  minSupportedBuild: number;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.ListRoundsResponse.
 * Use `create(ListRoundsResponseSchema)` to create a new message.
 */
export const ListRoundsResponseSchema: GenMessage<ListRoundsResponse> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 14);

/**
 * @generated from message chessstreamlive.broadcast.v1.Tournament
 */
export type Tournament = Message<"chessstreamlive.broadcast.v1.Tournament"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * @generated from field: chessstreamlive.broadcast.v1.TournamentInfo info = 4;
   */
  info?: TournamentInfo | undefined;

  /**
   * @generated from field: int64 created_at = 5;
   */
  createdAt: bigint;

  /**
   * @generated from field: string url = 6;
   */
  url: string;

  /**
   * @generated from field: optional int32 tier = 7;
   */
  tier?: number | undefined;

  /**
   * @generated from field: repeated int64 dates = 8;
   */
  dates: bigint[];

  /**
   * @generated from field: optional string image = 9;
   */
  image?: string | undefined;

  /**
   * @generated from field: repeated chessstreamlive.broadcast.v1.Round rounds = 10;
   */
  rounds: Round[];
};

/**
 * Describes the message chessstreamlive.broadcast.v1.Tournament.
 * Use `create(TournamentSchema)` to create a new message.
 */
export const TournamentSchema: GenMessage<Tournament> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 15);

/**
 * @generated from message chessstreamlive.broadcast.v1.TournamentInfo
 */
export type TournamentInfo = Message<"chessstreamlive.broadcast.v1.TournamentInfo"> & {
  /**
   * @generated from field: optional string format = 1;
   */
  format?: string | undefined;

  /**
   * @generated from field: optional string tc = 2;
   */
  tc?: string | undefined;

  /**
   * @generated from field: optional string fide_tc = 3;
   */
  fideTc?: string | undefined;

  /**
   * @generated from field: optional string location = 4;
   */
  location?: string | undefined;

  /**
   * @generated from field: optional string time_zone = 5;
   */
  timeZone?: string | undefined;

  /**
   * @generated from field: optional string players = 6;
   */
  players?: string | undefined;

  /**
   * @generated from field: optional string website = 7;
   */
  website?: string | undefined;

  /**
   * @generated from field: optional string standings = 8;
   */
  standings?: string | undefined;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.TournamentInfo.
 * Use `create(TournamentInfoSchema)` to create a new message.
 */
export const TournamentInfoSchema: GenMessage<TournamentInfo> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 16);

/**
 * @generated from message chessstreamlive.broadcast.v1.Round
 */
export type Round = Message<"chessstreamlive.broadcast.v1.Round"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * @generated from field: bool ongoing = 4;
   */
  ongoing: boolean;

  /**
   * @generated from field: bool finished = 5;
   */
  finished: boolean;

  /**
   * @generated from field: optional int64 starts_at = 6;
   */
  startsAt?: bigint | undefined;

  /**
   * @generated from field: optional string url = 7;
   */
  url?: string | undefined;
};

/**
 * Describes the message chessstreamlive.broadcast.v1.Round.
 * Use `create(RoundSchema)` to create a new message.
 */
export const RoundSchema: GenMessage<Round> = /*@__PURE__*/
  messageDesc(file_broadcast_live, 17);

/**
 * See Hydration.position_basis.
 *
 * @generated from enum chessstreamlive.broadcast.v1.HydrationBasis
 */
export enum HydrationBasis {
  /**
   * Legacy producer — absence is unknown; a cache MAY fill the gap.
   *
   * @generated from enum value: HYDRATION_BASIS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Position replay + stores succeeded: absences are authoritative
   * (out of book / not a novelty).
   *
   * @generated from enum value: HYDRATION_BASIS_COMPUTED = 1;
   */
  COMPUTED = 1,

  /**
   * Position replay failed (illegal SAN, unparseable movetext): the
   * position-derived components were deliberately skipped.
   *
   * @generated from enum value: HYDRATION_BASIS_SKIPPED = 2;
   */
  SKIPPED = 2,

  /**
   * An opening/novelty store read ERRORED (not a miss): absences are
   * gaps a cache may fill.
   *
   * @generated from enum value: HYDRATION_BASIS_DEGRADED = 3;
   */
  DEGRADED = 3,
}

/**
 * Describes the enum chessstreamlive.broadcast.v1.HydrationBasis.
 */
export const HydrationBasisSchema: GenEnum<HydrationBasis> = /*@__PURE__*/
  enumDesc(file_broadcast_live, 0);

/**
 * @generated from enum chessstreamlive.broadcast.v1.Trend
 */
export enum Trend {
  /**
   * @generated from enum value: TREND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TREND_UP = 1;
   */
  UP = 1,

  /**
   * @generated from enum value: TREND_STABLE = 2;
   */
  STABLE = 2,

  /**
   * @generated from enum value: TREND_DOWN = 3;
   */
  DOWN = 3,
}

/**
 * Describes the enum chessstreamlive.broadcast.v1.Trend.
 */
export const TrendSchema: GenEnum<Trend> = /*@__PURE__*/
  enumDesc(file_broadcast_live, 1);

/**
 * Why GameUpdate.moves may be absent or partial (#732 discipline: it is a
 * statement, not a gap; consumers MUST NOT guess or backfill).
 *
 * @generated from enum chessstreamlive.broadcast.v1.MovesBasis
 */
export enum MovesBasis {
  /**
   * legacy producer — pre-structured-moves build
   *
   * @generated from enum value: MOVES_BASIS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * moves[] is the complete parse of GameUpdate.pgn.
   *
   * @generated from enum value: MOVES_BASIS_COMPLETE = 1;
   */
  COMPLETE = 1,

  /**
   * Structured build degraded: moves[] is the LONGEST VALID PREFIX of the
   * game (a parse failure at ply k ships plies 1..k-1 — never empty-on-
   * partial, never san-without-uci). The pgn escrow is still authoritative
   * and complete. Consumers render the prefix plus an explicit degraded
   * state; they never guess.
   *
   * @generated from enum value: MOVES_BASIS_DEGRADED = 2;
   */
  DEGRADED = 2,
}

/**
 * Describes the enum chessstreamlive.broadcast.v1.MovesBasis.
 */
export const MovesBasisSchema: GenEnum<MovesBasis> = /*@__PURE__*/
  enumDesc(file_broadcast_live, 2);

/**
 * @generated from service chessstreamlive.broadcast.v1.Broadcast
 */
export const Broadcast: GenService<{
  /**
   * One h2 connection per client; one server-stream per subscribed round —
   * HTTP/2 streams are the multiplexer. Unsubscribe = cancel the stream.
   * First messages on subscribe: latest GameUpdate snapshot per board
   * (late-joiner catch-up), then live updates. Subscribing to a finished
   * round yields snapshots + RoundFinished, then the stream closes OK.
   *
   * @generated from rpc chessstreamlive.broadcast.v1.Broadcast.Subscribe
   */
  subscribe: {
    methodKind: "server_streaming";
    input: typeof SubscribeRequestSchema;
    output: typeof UpdateSchema;
  },
  /**
   * Tournament/round metadata, served from the distributor's cache of the
   * relay's TournamentSync state. Replaces the legacy /broadcasts/top fetch.
   *
   * @generated from rpc chessstreamlive.broadcast.v1.Broadcast.ListRounds
   */
  listRounds: {
    methodKind: "unary";
    input: typeof ListRoundsRequestSchema;
    output: typeof ListRoundsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_broadcast_live, 0);

